import { Tx, TxStatus } from 'interfaces/tx.interface'
import { makeAutoObservable } from 'mobx'

class TxStore {
  txs: Record<string, Tx>

  constructor() {
    this.txs = {}
    makeAutoObservable(this)
  }

  setTxs = (value: Record<string, any>) => {
    this.txs = { ...value }
  }

  addTx = (txHash: string, description: string) => {
    this.txs[txHash] = {
      txHash: txHash,
      description,
      status: TxStatus.PENDING_APPROVE,
    }
  }

  removeTx = (txHash: string) => {
    if (txHash in this.txs) {
      delete this.txs[txHash]
    }
  }

  updateTx = (txHash: string, value: Partial<Tx>) => {
    this.txs[txHash] = { ...this.txs[txHash], ...value }
  }

  clear = () => {
    this.txs = {}
  }
}

export const txStore = new TxStore()
